import { render, staticRenderFns } from "./GlobalNavigation.vue?vue&type=template&id=2405b890&scoped=true"
import script from "./GlobalNavigation.vue?vue&type=script&lang=js"
export * from "./GlobalNavigation.vue?vue&type=script&lang=js"
import style0 from "./GlobalNavigation.vue?vue&type=style&index=0&id=2405b890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2405b890",
  null
  
)

export default component.exports